/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Bot_SnoozeInputs */

const tr_landing_pricerules_mock_bot_snooze = /** @type {(inputs: Landing_Pricerules_Mock_Bot_SnoozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ertele`)
};

const en_landing_pricerules_mock_bot_snooze = /** @type {(inputs: Landing_Pricerules_Mock_Bot_SnoozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snooze`)
};

const de_landing_pricerules_mock_bot_snooze = /** @type {(inputs: Landing_Pricerules_Mock_Bot_SnoozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Später`)
};

const ru_landing_pricerules_mock_bot_snooze = /** @type {(inputs: Landing_Pricerules_Mock_Bot_SnoozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отложить`)
};

/**
* | output |
* | --- |
* | "Snooze" |
*
* @param {Landing_Pricerules_Mock_Bot_SnoozeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_bot_snooze = /** @type {((inputs?: Landing_Pricerules_Mock_Bot_SnoozeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Bot_SnoozeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_bot_snooze(inputs)
	if (locale === "de") return de_landing_pricerules_mock_bot_snooze(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_bot_snooze(inputs)
	return tr_landing_pricerules_mock_bot_snooze(inputs)
});